module.exports = __webpack_public_path__ + "img/116014.c626aae9.png";